import useSubmitButtonName from 'hooks/forms/useSubmitButtonName';
import useSubmit from 'hooks/forms/useSubmitForm';
import { message } from 'antd';
import I18n from 'i18n-js';

const normalizeSelectValue = (value) => {
  if (value && typeof value === 'object' && 'value' in value) {
    return value.value;
  }
  return value ?? null;
};

const buildFormParams = ({ form }) => {
  const rawValues = form.getFieldsValue();

  return {
    ticket: Object.fromEntries(
      Object.entries(rawValues).map(([key, value]) => {
        if (['author_id', 'assignee_id', 'responsible_user_id'].includes(key)) {
          return [key, normalizeSelectValue(value)];
        }

        return [key, value ?? null];
      }),
    ),
  };
};

const useSubmitForm = ({
  id,
  form,
  formUrl,
  clearErrors,
  handleError,
  setIsModalOpen,
  setInitialTickets,
  ticketFromDashboard,
}) => {
  const { handleSubmitForm, isFormSending } = useSubmit({
    formUrl,
    handleError,
    objectId: id,
    beforeSubmitForm: clearErrors,
    buildFormParams: () => (buildFormParams({ form })),
    afterSuccessSubmitForm: ({ data }) => {
      form.resetFields();
      setIsModalOpen(false);

      if (ticketFromDashboard) {
        setInitialTickets(data.filteredTickets);
      } else {
        globalThis.location.href = data.redirectUrl;
      }

      message.success(I18n.t(id ? 'flash.tickets.updated' : 'flash.tickets.created'));
    },
  });

  const handleSubmitWrapper = (formData) => {
    clearErrors();
    handleSubmitForm(formData);
  };

  const submitButtonName = useSubmitButtonName({
    objectId: id,
    isFormSending,
    modelName: 'ticket',
  });

  return {
    isFormSending,
    submitButtonName,
    handleSubmitForm: handleSubmitWrapper,
  };
};

export default useSubmitForm;
